import { GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { PageDataFetchError } from "@looksrare/utils";
import { HelpView } from "@looksrare/yolo";
import { getCanonicalAndLanguageAlternates } from "@/utils/seo";
import { Page } from "@/components";
import { YoloGamesYoloProvider } from "@/components/YoloGamesYoloProvider";
import { getChainInfo } from "@/utils";

const path = "/yolo/help";

const HelpPage = () => {
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  const title = "YOLO | FAQs";
  const description =
    "Browse the frequently asked questions about YOLO — YOLO Games' heart-pounding on-chain experience, where users deposit crypto for a chance at winning big.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(path, router, currentChainInfo.appUrl);

  return (
    <Page title={title}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title,
          description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/yolo/meta.png`,
              alt: title,
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <YoloGamesYoloProvider>
        <HelpView />
      </YoloGamesYoloProvider>
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(locale, ["yolo", "common"])),
        locale,
      },
    };
  } catch (e) {
    console.error(e);
    throw new PageDataFetchError(path, e);
  }
};

export default HelpPage;
